/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * use or blocked.
 */
export const AuthClientAudienceRuleLevel = {
  Use: "use",
  Blocked: "blocked",
} as const;
/**
 * use or blocked.
 */
export type AuthClientAudienceRuleLevel = ClosedEnum<
  typeof AuthClientAudienceRuleLevel
>;

/**
 * A rule to store for an auth client.
 */
export type AuthClientAudienceRule = {
  /**
   * use or blocked.
   */
  level: AuthClientAudienceRuleLevel;
  /**
   * user:<id>, user:all, role:<id> or agent:<id>.
   */
  principalUrn: string;
};

/** @internal */
export const AuthClientAudienceRuleLevel$outboundSchema: z.ZodMiniEnum<
  typeof AuthClientAudienceRuleLevel
> = z.enum(AuthClientAudienceRuleLevel);

/** @internal */
export type AuthClientAudienceRule$Outbound = {
  level: string;
  principal_urn: string;
};

/** @internal */
export const AuthClientAudienceRule$outboundSchema: z.ZodMiniType<
  AuthClientAudienceRule$Outbound,
  AuthClientAudienceRule
> = z.pipe(
  z.object({
    level: AuthClientAudienceRuleLevel$outboundSchema,
    principalUrn: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalUrn: "principal_urn",
    });
  }),
);

export function authClientAudienceRuleToJSON(
  authClientAudienceRule: AuthClientAudienceRule,
): string {
  return JSON.stringify(
    AuthClientAudienceRule$outboundSchema.parse(authClientAudienceRule),
  );
}
